import React from 'react';

import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import globalMessages from 'translations/messages/global-messages';

const AlignJustify = ({ intl, title, size = 20 }) => (
  <Tooltip
    title={title ?? intl.formatMessage(globalMessages.align_justify)}
    placement="bottom"
    enterDelay={500}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 1.5 20 18"
      fill="none"
      focusable="false"
      style={{ display: 'block' }}
    >
      <rect x="2" y="5" width="16" height="1.7" rx="0.85" fill="currentColor" />
      <rect x="2" y="8.5" width="16" height="1.7" rx="0.85" fill="currentColor" />
      <rect x="2" y="12" width="16" height="1.7" rx="0.85" fill="currentColor" />
      <rect x="2" y="15.5" width="16" height="1.7" rx="0.85" fill="currentColor" />
    </svg>
  </Tooltip>
);

AlignJustify.propTypes = {
  intl: PropTypes.object,
  title: PropTypes.string,
  size: PropTypes.number,
};

export default injectIntl(AlignJustify);
